import React from "react";

const NotAuthorized = () => {
  return <div>NotAuthorized</div>;
};

export default NotAuthorized;
